const types = ['BULK', 'BULKTANK', 'CAR', 'CONT', 'LIVESTOCK', 'MPP', 'PASS', 'PASSCAR', 'REEFER', 'TANK'];

export const LIQUID_TYPES_BY_PURPOSE = ['BULKTANK', 'TANK'];

export { types };



// WEBPACK FOOTER //
// ./app/constants/vesselTypes.js